<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          Реквизиты документа, подтверждающие полномочия представителя
        </div>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.authorityInfo.$model"
          :errorMessages="getValidationErrorText(v.authorityInfo)"
          label="Полномочия представителя"
          outlined
          disabled
        />
      </v-col>

      <v-col cols="6">
        <DateFieldCustom
          label="Дата выдачи доверенности"
          :value="v.issueDate.$model"
          @change="v.issueDate.$model = $event"
          :errorMessage="v.issueDate"
          :max="new Date().toISOString()"
          disabled
        />
      </v-col>
      <v-col cols="6">
        <DateFieldCustom
          label="Срок действия доверенности"
          :value="v.issueExpirationDate.$model"
          @change="v.issueExpirationDate.$model = $event"
          :errorMessage="v.issueExpirationDate"
          disabled
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.issueNumber.$model"
          :errorMessages="getValidationErrorText(v.issueNumber)"
          label="Единый регистрационный номер доверенности"
          outlined
          disabled
        />
      </v-col>

      <v-col cols="12">
        <p>
          Идентифицирующие сведения об информационной системе, которая
          предоставляет техническую возможность получения информации о досрочном
          прекращении действия доверенности, в том числе в силу ее отмены
          доверителем
        </p>
        <v-text-field
          v-model="v.systemId.$model"
          :errorMessages="getValidationErrorText(v.systemId)"
          outlined
          disabled
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import { required } from 'vuelidate/lib/validators';

export const baseAuthorityValidation = {
  authorityInfo: { required },
  issueDate: { required },
  issueExpirationDate: { required },
  issueNumber: { required },
  systemId: { required },
  mrpIssuerInn: {},
};

export const baseAuthorityModel = {
  authorityInfo: '',
  issueDate: '',
  issueExpirationDate: '',
  issueNumber: '',
  systemId: '',
  mrpIssuerInn: '',
};

export default {
  name: 'BaseAuthority',
  components: {
    DateFieldCustom,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
